import React, { useEffect, useState } from 'react';
import { Card, InputNumber, Table } from 'antd';
import { Dayjs } from 'dayjs';
import { render } from '@testing-library/react';
import { commaSeparatedString } from '../../utils/utils';
import { MinusSquareOutlined, PlusSquareTwoTone, MinusSquareTwoTone  } from '@ant-design/icons'
import { useCurrency } from '../../context/CurrencyContext';

interface RowData {
  key: string;
  role: string;
  children?: Array<any>;
}

interface columnDef {
  title: string;
  dataIndex: string;
  key: string;
}

const data: RowData[] = [
  {
    key: 'month1',
    role: 'US - Data Science - Sr Manager',
    children: [
      {
        key: '1-1',
        role: 'Billable Hours',
        month0: '39',
        month1: '78',
        month2: '78',
        month3: '78',
        month4: '78',
        month5: '78',
        total: '429',
      },
      {
        key: '1-2',
        role: 'Revenue $',
        month0: '$ 10,335',
        month1: '$ 20,670',
        month2: '$ 20,670',
        month3: '$ 20,670',
        month4: '$ 20,670',
        month5: '$ 20,670',
        total: '$ 113,685',
      },
      {
        key: '1-3',
        role: 'Cost $',
        month0: '$ 4,199',
        month1: '$ 8,398',
        month2: '$ 8,398',
        month3: '$ 8,398',
        month4: '$ 8,398',
        month5: '$ 8,398',
        total: '$ 46,189',
      },
      {
        key: '1-4',
        role: 'Client Margin $',
        month0: '$ 6,136',
        month1: '$ 12,272',
        month2: '$ 12,272',
        month3: '$ 12,272',
        month4: '$ 12,272',
        month5: '$ 12,272',
        total: '$ 67,496',
      },
    ],
  },
  {
    key: 'month2',
    role: 'MVL - DEE - Engineering - Sr Analyst',
    children: [
      {
        key: '2-1',
        role: 'Billable Hours',
        month0: '39',
        month1: '78',
        month2: '78',
        month3: '78',
        month4: '78',
        month5: '78',
        total: '431',
      },
      {
        key: '2-2',
        role: 'Revenue $',
        month0: '$ 2,742',
        month1: '$ 5,483',
        month2: '$ 5,483',
        month3: '$ 5,483',
        month4: '$ 5,483',
        month5: '$ 5,483',
        total: '$ 30,158',
      },
      {
        key: '2-3',
        role: 'Cost $',
        month0: '$ 846',
        month1: '$ 1,691',
        month2: '$ 1,691',
        month3: '$ 1,691',
        month4: '$ 1,691',
        month5: '$ 1,691',
        total: '$ 9,303',
      },
      {
        key: '2-4',
        role: 'Client Margin $',
        month0: '$ 1,896',
        month1: '$ 3,792',
        month2: '$ 3,792',
        month3: '$ 3,792',
        month4: '$ 3,792',
        month5: '$ 3,792',
        total: '$ 20,856',
      },
    ],
  },
  {
    key: 'month3',
    role: 'IDC - DEE - Engineering - Lead Analyst',
    children: [
      {
        key: '3-1',
        role: 'Billable Hours',
        month0: '75',
        month1: '149',
        month2: '149',
        month3: '149',
        month4: '149',
        month5: '149',
        total: '821',
      },
      {
        key: '3-2',
        role: 'Revenue $',
        month0: '$ 6,720',
        month1: '$ 13,440',
        month2: '$ 13,440',
        month3: '$ 13,440',
        month4: '$ 13,440',
        month5: '$ 13,440',
        total: '$ 73,920',
      },
      {
        key: '3-3',
        role: 'Cost $',
        month0: '2,133',
        month1: "4,267",
        month2: '4,267',
        month3: '4,267',
        month4: '4,267',
        month5: "4,267",
        total: '23,468',
      },
      {
        key: '3-4',
        role: 'Client Margin $',
        month0: '$ 4,587',
        month1: '$ 9,173',
        month2: '$ 9,173',
        month3: '$ 9,173',
        month4: '$ 9,173',
        month5: '$ 9,173',
        total: '$ 50,452',
      },
    ],
  },
  {
    key: 'month4',
    role: 'Total Non-IS Monthly Summary',
    children: [
      {
        key: '4-1',
        role: 'Total Non-IS Revenue',
        month0: '$ 19,797',
        month1: '$ 39,593',
        month2: '$ 39,593',
        month3: '$ 39,593',
        month4: '$ 39,593',
        month5: '$ 39,593',
        total: '$ 217,763',
      },
      {
        key: '4-2',
        role: 'Total Billable Hours',
        month0: '153',
        month1: '306',
        month2: '306',
        month3: '306',
        month4: '306',
        month5: '306',
        total: '1681',
      },
      {
        key: '4-3',
        role: 'Total Cost $',
        month0: '$ 7,178',
        month1: '$ 14,356',
        month2: '$ 14,356',
        month3: '$ 14,356',
        month4: '$ 14,356',
        month5: '$ 14,356',
        total: '$ 78,960',
      },
      {
        key: '4-4',
        role: 'Total Client Margin $',
        month0: '$ 12,619',
        month1: '$ 25,237',
        month2: '$ 25,237',
        month3: '$ 25,237',
        month4: '$ 25,237',
        month5: '$ 25,237',
        total: '$ 138,804',
      },
      {
        key: '4-5',
        role: 'Client Margin %',
        month0: '63.7 %',
        month1: '63.7 %',
        month2: '63.7 %',
        month3: '63.7 %',
        month4: '63.7 %',
        month5: '63.7 %',
        total: '63.7 %',
      },
    ],
  },
];

interface DealRevenueProps {
  title: string;
  monthColumns: string[];
  duration: number;
  startDate: Dayjs;
  dataSource?: Array<RowData>;
  pagination?: boolean;
}

// Incomplete Just the Layout have to make it dynamic
const ProjectRevenue = ({ title, monthColumns, duration, startDate, dataSource = data, pagination = false }: DealRevenueProps) => {
  const { dealCurrency, currencySymbol, updateCurrency } = useCurrency();
  const [columns, setColumns] = useState<any[]>([]);
  const [rowData, setRowData] = useState<any[]>([]);
  const [expandedRowKeys, setExpandedRowKeys] = useState<any[]>([]);

  const handleExpandAll = () => {
    if(expandedRowKeys.length !== rowData.length) {
      setExpandedRowKeys(rowData.map(row => row.key))
    } else {
      setExpandedRowKeys([])
    }
  }
  useEffect(() => {
    const rowDataSource = dataSource.map((row: any) => {
      const children = row.children.filter((child: any) => child.role !== `Target Revenue ${currencySymbol}` && child.role !== `Target Margin ${currencySymbol}`);
      return { ...row, children }
    });
    setRowData(rowDataSource);
  }, [dataSource]);
  useEffect(() => {
    const generateColumns = () => {
      const cols = [
        {
          title: <div style={{cursor: 'pointer', display: 'flex', paddingLeft: '4px'}} onClick={handleExpandAll}>{expandedRowKeys.length !== rowData.length ? expandedRowKeys.length == 0 ? <PlusSquareTwoTone />: <MinusSquareOutlined /> : <MinusSquareTwoTone />}</div>,
          dataIndex: 'expandControl',
          key: 'expandControl',
          width: 50, // Fixed width for the column
        },
        {
          title: 'Role',
          dataIndex: 'role',
          key: 'role',
          className: 'title-column',
        },
        {
          title: 'Total',
          dataIndex: 'total',
          key: 'total',
          align:'right',
          className: 'total-column',
          render: (text: string, record:any) => text ? text.toString().includes('%') ? text : record['role'] == 'Billable Hours' ? commaSeparatedString(text) : `${currencySymbol} ${commaSeparatedString(text)}` : text,
        },
      ];

      const dynamicMonthCols = monthColumns.map((monthTitle, i) => ({
        title: monthTitle,
        dataIndex: `month${i}`,
        key: `month${i}`,
        align:'right',
        className: 'month-column',
        render: (text: string, record:any) => text ? text.toString().includes('%') ? text : record['role'] == 'Billable Hours' ? commaSeparatedString(text) : `${currencySymbol} ${commaSeparatedString(text)}` : text,
      }));

      return [...cols.slice(0, 2), ...dynamicMonthCols, ...cols.slice(-1)];
    };

    setColumns(generateColumns());
  }, [monthColumns, expandedRowKeys]);
  return (
    <Card title={title} style={{ marginBottom: '16px' }}>
      <div style={{ width: '100%', overflowY: 'auto' }}>
        <Table
          className='project-revenue-table'
          dataSource={rowData}
          columns={columns}
          expandable={{
            defaultExpandedRowKeys: ["4"],     
            expandedRowKeys: expandedRowKeys,
            onExpand: (expanded, record) => {
              if(expanded) {
                setExpandedRowKeys([...expandedRowKeys, record.key])
              } else {
                setExpandedRowKeys(expandedRowKeys.filter((k)=> k!=record.key))
              }
            }
          }}
          rowKey="key"
          pagination={false}
          size="small"
          scroll={{ x: '100%' }}
          style={{ marginBottom: '16px' }}
        />
      </div>
    </Card>
  );
};

export default ProjectRevenue;